import { useState } from 'react'
import { TooltipProvider } from '@shared/components/ui/tooltip'
import { SearchModal } from '@shared/components/search/SearchModal'
import { TopBarActions } from './TopBarActions'

export function TopBar() {
  const [searchOpen, setSearchOpen] = useState(false)

  return (
    <TooltipProvider>
      <header className="sticky top-0 z-40 flex h-10 items-center justify-end bg-background/95 backdrop-blur-sm px-4 sm:px-6">
        <TopBarActions onSearchOpen={() => setSearchOpen(true)} />
      </header>
      <SearchModal open={searchOpen} onOpenChange={setSearchOpen} />
    </TooltipProvider>
  )
}
